import { createTheme } from '@mui/material/styles';
import Color from 'color2';

import * as colors from './colors';

const fontSize = 14; // px
const htmlFontSize = 16;
const coef = fontSize / 14;
export const pxToRem = size => `${(size / htmlFontSize) * coef}rem`;

const muiTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': {
          height: '100%',
        },
        body: {
          fontFamily: 'Roboto, Helvetica, sans-serif',
          fontWeight: 'normal',
          fontSize: pxToRem(13),
          margin: '0',
          padding: '0',
          lineHeight: 1,
        },
        html: {
          boxSizing: 'border-box',
          WebkitFontSmoothing: 'auto',
        },

        '*, *:before, *:after': {
          boxSizing: 'inherit',
        },
        'a, a:hover, a:visited': {
          textDecoration: 'inherit',
          outline: 'none',
        },
        // Scrollbar
        '::-webkit-scrollbar-button': {
          display: 'none',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: colors.sanMarino,
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: colors.darkSanMarino,
          },
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'initial',
        },
        text: {
          color: colors.mako,
        },
        containedPrimary: {
          backgroundColor: colors.karimunBlue,
          '&:hover': {
            backgroundColor: colors.googleBlue,
          },
        },
      },
    },
  },

  colors,
});

export default muiTheme;
